import React from 'react'
import Transition from './page-transition'

export default ({ element, props }) => (
  <Transition {...props} style={{ margin: 0 }}>
    {element}
  </Transition>
)
